

























import { Watch, Component, Prop, Vue, Inject } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { CreateActionModel } from '@/components/form/CreateActionForm.vue'
import { ActionType, ReferralStatus } from '@/api/types'
import { ActionAPI, ReferralAPI } from '@/api/backend-client'
import { Action } from '@/api/model/action'
import { v4 as uuid } from 'uuid'

@Component
export default class CreateOrderModal extends Vue {
    @Prop({ required: true }) readonly referral!: Referral
    @Prop({ type: Boolean, default: false }) value!: boolean

    visible: boolean = false

    formCreateAction: CreateActionModel = { notify: false, actionDate: null, type: ActionType.MEETING }
    submittingCreateAction: boolean = false

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async createAction(): Promise<void> {
        this.submittingCreateAction = true

        if (!this.$currentCompany.pipelinesEnabled) {
            const statusses = [
                ReferralStatus.NEW,
                ReferralStatus.PENDING,
                ReferralStatus.UNREACHABLE,
            ]

            // If one of above status
            if (statusses.includes(this.referral.status)) {

                // Ask if we should update referral status also.
                if (confirm(this.$t('edit-task-modal.change-status-to-appointment').toString())) {

                    await ReferralAPI.update(this.referral.id, {
                        ...this.referral,
                        status: ReferralStatus.APPOINTMENT,
                        statusReason: null,
                    } as Referral)
                }
            }
        }

        // api
        await ActionAPI.create({
            ...Action.fromData({
                referral: this.referral,
                type: this.formCreateAction.type,
                appointmentType: this.formCreateAction.appointmentType,
                actionDate: this.formCreateAction.actionDate,
                assignedTo: this.formCreateAction.assignedTo,
                comment: this.formCreateAction.comment,
                id: uuid(),
                createdBy: this.$currentUser.resourceIdentifier,
            }),

            // @todo: not actually part of the model, should be a seperate call
            // @ts-ignore
            informAssignedTo: this.formCreateAction.notify,
        })

        this.submittingCreateAction = false

        this.$emit('on-save', true)
    }
}
